import React from 'react';
import Legend from '../components/Legend';
import useQueryString from '../../hooks/useQueryString';
import { FILTER } from '../constants';

export default () => {
  const { filter: selectedFilter } = useQueryString();

  if (selectedFilter !== FILTER.GOODS_STATUS) return <></>;

  return <Legend />;
};
